import { render } from "./BlackWhiteTemplate.vue?vue&type=template&id=d80fea9a"
import script from "./BlackWhiteTemplate.vue?vue&type=script&lang=js"
export * from "./BlackWhiteTemplate.vue?vue&type=script&lang=js"

import "./BlackWhiteTemplate.vue?vue&type=style&index=0&id=d80fea9a&lang=postcss"

import exportComponent from "C:\\Users\\antho\\Documents\\Projects\\ynforma-website\\ynforma-website-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__